import { render, staticRenderFns } from "./ProductDetailsLink.vue?vue&type=template&id=11a8f1be"
import script from "./ProductDetailsLink.vue?vue&type=script&lang=ts"
export * from "./ProductDetailsLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports